import { GridColumn } from 'src/components/GridWrapper';
import PoStatus from 'src/sections/enter_receipt/custom_grid_cell/PoStatus';
import PoLineItemInfoCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/PoLineItemInfoCell';
import PoNumberCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/PoNumberCell';
import SelectPoActionCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/SelectPoActionCell';
import StatusDateCell from 'src/sections/invoice_scan_manager/ocr/ocr_cell/StatusDateCell';

const matchPoColumns: GridColumn<any>[] = [
  {
    field: 'errors',
    title: '',
    width: 40,
    menu: false,
    sortable: false,
    component: PoLineItemInfoCell,
  },
  {
    field: 'poNumber',
    title: 'PO #',
    filter: 'text',
    dataType: 'string',
    component: PoNumberCell,
  },
  {
    field: 'companyName',
    title: 'Company',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'numberOfInvoices',
    title: '# of Docs',
    filter: 'numeric',
    dataType: 'number',
    filterFormat: '#',
    step: 1,
  },
  {
    field: 'status',
    title: 'Status',
    filter: 'text',
    dataType: 'string',
    component: PoStatus,
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    filter: 'date',
    dataType: 'date',
    component: StatusDateCell,
    format: 'MM/dd/yyyy',
  },
  {
    field: 'supplierName',
    title: 'Supplier Name',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'buyerName',
    title: 'Buyer',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'subject',
    title: 'Subject',
    filter: 'text',
    dataType: 'string',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    dataType: 'dollar',
    format: '{0:c2}',
    filterFormat: 'c',
  },
  {
    field: 'hasPoAccess',
    title: 'Actions',
    component: SelectPoActionCell,
    menu: false,
  },
];

export default matchPoColumns;
